import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  Grid,
  List,
  ListItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import CodeForm from "../../components/system-management/code-form";
import CodeGroupForm from "../../components/system-management/code-group-form";
import {
  codeGroupCreateRequestAction,
  codeGroupSelectAction,
  codeSelectAction,
  codeSortAction,
  loadCodeGroupAction,
  saveSortAction,
} from "../../redux/reducers/codeManagement";

const useStyles = makeStyles((theme) => ({
  codeGroup: {
    width: "100%",
    maxWidth: 620,
    fontSize: "12px",
  },
  alert: {
    justifyContent: "center",
  },
}));

export default function CodeManagement() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [selectCodeGroup, setSelectCodeGroup] = React.useState("");
  const { codeGroupList } = useSelector((state) => state.codeManagement);
  const { codeList } = useSelector((state) => state.codeManagement);
  const [isShowCodeGroup, setIsShowCodeGroup] = React.useState(false);
  const [isShowCode, setIsShowCode] = React.useState(false);
  const [selectCode, setSelectCode] = React.useState("");
  const [openSort, setOpenSort] = useState(false);
  const [openSortComplete, setOpenSortComplete] = useState(false);

  useEffect(() => {
    dispatch(loadCodeGroupAction());
  }, []);

  const handleSelectCodeGroup = (event, code) => {
    setSelectCodeGroup(code);
    setSelectCode("");
    setIsShowCodeGroup(true);
    setIsShowCode(false);

    dispatch(codeGroupSelectAction(code));
    dispatch(codeSelectAction(""));
  };

  const handleSelectCode = (event, code) => {
    setSelectCode(code);
    setIsShowCode(true);
    setIsShowCodeGroup(false);

    dispatch(codeSelectAction(code));
  };

  const submitCodeGroup = (data) => {
    dispatch(codeGroupCreateRequestAction(data));
  };

  const handleAddCodeGroup = () => {
    setIsShowCodeGroup(true);
    setIsShowCode(false);
    setSelectCodeGroup("");

    dispatch(codeGroupSelectAction());
  };

  const handleAddCode = () => {
    setIsShowCode(true);
    setIsShowCodeGroup(false);
    setSelectCode("");

    dispatch(codeSelectAction());
  };

  const handleClose = () => {
    setIsShowCode(false);
    setIsShowCodeGroup(false);
  };

  const handleSort = (direction) => {
    let list = JSON.parse(JSON.stringify(codeList));

    let sortItem = _.remove(list, (item) => {
      return item.cd == selectCode;
    })[0];

    if (direction == "up") {
      list.unshift(sortItem);
    } else {
      list.push(sortItem);
    }

    dispatch(codeSortAction(list));
  };

  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm();

  const handleSortClose = () => {
    setOpenSort(false);
  };

  const handleSortOK = () => {
    let result = [];

    _.forEach(codeList, (item) => {
      result.push(item.cd);
    });

    dispatch(saveSortAction(result));
    setOpenSort(false);
    setOpenSortComplete(true);
  };

  const handleSortCompleteClose = () => {
    setOpenSortComplete(false);
  };

  return (
    <main id="main">
      <div className="h-group">
        <h2>코드관리</h2>
      </div>

      <div className="contents-wrap">
        <Grid container spacing={3} justifyContent="flex-end">
          <Grid item xs={6} className="code-box">
            <h3 className="tit-3">코드그룹</h3>
            <Card>
              <CardContent className="p-0">
                <List
                  className="list-scroller scroll"
                  component="nav"
                  aria-label="main mailbox folders"
                >
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  <ListItem>1</ListItem>
                  {/* {codeGroupList.map((list) => (
                    <ListItem
                      button
                      selected={selectCodeGroup === list.cd}
                      key={list.cd}
                      onClick={(event) => handleSelectCodeGroup(event, list.cd)}
                    >
                      {list.nm}
                    </ListItem>
                  ))} */}
                </List>
              </CardContent>
              <Divider />
              <CardActions>
                <Grid container>
                  <Grid item xs={12}>
                    코드 그룹
                  </Grid>
                </Grid>
              </CardActions>
            </Card>
            <Grid container spacing={3} className="mt-1">
              <Grid item xs={12}>
                <Box mt={1}>
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    onClick={handleAddCodeGroup}
                  >
                    코드그룹 추가
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <h3>코드</h3>
            <Card>
              <CardContent className="p-0">
                <List
                  className="list-scroller"
                  component="nav"
                  aria-label="main mailbox folders"
                >
                  {codeList.map((list) => (
                    <ListItem
                      button
                      selected={selectCode === list.cd}
                      key={list.cd}
                      onClick={(event) => handleSelectCode(event, list.cd)}
                    >
                      {list.nm}
                    </ListItem>
                  ))}
                </List>
              </CardContent>
              <Divider />
              <CardActions>
                <Grid container>
                  <Grid item xs={3}>
                    코드
                  </Grid>
                  <Grid item xs={9}>
                    <Box display="flex" justifyContent="flex-end">
                      <Box mr={1}>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleSort("up");
                          }}
                        >
                          맨위▲
                        </a>
                      </Box>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleSort("down");
                        }}
                      >
                        맨아래▼
                      </a>
                    </Box>
                  </Grid>
                </Grid>
              </CardActions>
            </Card>
            <Grid container spacing={3} className="mt-1">
              <Grid item xs={6}>
                {selectCodeGroup && (
                  <Box mt={1}>
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={handleAddCode}
                    >
                      코드 추가
                    </Button>
                  </Box>
                )}
              </Grid>
              <Grid item xs={6} className="text-end">
                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    onClick={(e) => {
                      setOpenSort(true);
                    }}
                  >
                    정렬 저장
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {isShowCodeGroup == true && <CodeGroupForm handleClose={handleClose} />}
      {isShowCode == true && <CodeForm handleClose={handleClose} />}

      <Dialog
        open={openSort}
        onClose={handleSortClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"저장하시겠습니까?"}</DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleSortClose}
            color="secondary"
          >
            취소
          </Button>
          <Button
            variant="contained"
            onClick={handleSortOK}
            color="primary"
            autoFocus
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSortComplete}
        onClose={handleSortCompleteClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"저장하였습니다."}</DialogTitle>
        <DialogActions className={classes.alert}>
          <Button
            variant="contained"
            onClick={handleSortCompleteClose}
            color="primary"
            autoFocus
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </main>
  );
}
